import { Code, Github, Linkedin, Send } from "lucide-react";

export default function Footer() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <footer className="bg-sprintwise-dark text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-4 md:grid-cols-2 gap-8">
          <div data-testid="footer-brand">
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-8 h-8 bg-gradient-to-r from-sprintwise-primary to-sprintwise-secondary rounded-lg flex items-center justify-center">
                <Code className="text-white text-sm" />
              </div>
              <span className="text-xl font-bold gradient-text">Sprintwise</span>
            </div>
            <p className="text-gray-100 mb-6" data-testid="footer-description">
              Создаем качественные цифровые продукты на базе современных технологий
            </p>
            <div className="flex space-x-4">
              <Github className="w-5 h-5 text-gray-200 hover:text-white transition-colors cursor-pointer" data-testid="footer-github" />
              <Linkedin className="w-5 h-5 text-gray-200 hover:text-white transition-colors cursor-pointer" data-testid="footer-linkedin" />
              <Send className="w-5 h-5 text-gray-200 hover:text-white transition-colors cursor-pointer" data-testid="footer-telegram" />
              <svg className="w-5 h-5 text-gray-200 hover:text-white transition-colors cursor-pointer" viewBox="0 0 24 24" fill="currentColor" data-testid="footer-dribbble">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10c5.51 0 10-4.48 10-10S17.51 2 12 2zm6.605 4.61a8.502 8.502 0 011.93 5.314c-.281-.054-3.101-.629-5.943-.271-.065-.141-.12-.293-.184-.445a25.416 25.416 0 00-.564-1.236c3.145-1.28 4.577-3.124 4.761-3.362zM12 3.475c2.17 0 4.154.813 5.662 2.148-.152.216-1.443 1.941-4.48 3.08-1.399-2.57-2.95-4.675-3.189-5A8.687 8.687 0 0112 3.475zm-3.633.803a53.896 53.896 0 013.167 4.935c-3.992 1.063-7.517 1.04-7.896 1.04a8.581 8.581 0 014.729-5.975zM3.453 12.01v-.26c.37.01 4.512.065 8.775-1.215.25.477.477.965.694 1.453-.109.033-.228.065-.336.098-4.404 1.42-6.747 5.303-6.942 5.629a8.522 8.522 0 01-2.19-5.705zM12 20.547a8.482 8.482 0 01-5.239-1.8c.152-.315 1.888-3.656 6.703-5.337.022-.01.033-.01.054-.022a35.318 35.318 0 011.823 6.475 8.4 8.4 0 01-3.341.684zm4.761-1.465c-.086-.52-.542-3.015-1.659-6.084 2.679-.423 5.022.271 5.314.369a8.468 8.468 0 01-3.655 5.715z"/>
              </svg>
            </div>
          </div>
          
          <div data-testid="footer-services">
            <h3 className="text-lg font-semibold mb-4">Услуги</h3>
            <ul className="space-y-2">
              <li>
                <button 
                  onClick={() => scrollToSection('services')} 
                  className="text-gray-100 hover:text-white transition-colors text-left"
                  data-testid="footer-link-web"
                >
                  Веб-разработка
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('services')} 
                  className="text-gray-100 hover:text-white transition-colors text-left"
                  data-testid="footer-link-mobile"
                >
                  Мобильные приложения
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('services')} 
                  className="text-gray-100 hover:text-white transition-colors text-left"
                  data-testid="footer-link-api"
                >
                  API и интеграции
                </button>
              </li>
              <li>
                <span className="text-gray-100 hover:text-white transition-colors cursor-pointer" data-testid="footer-link-support">
                  Техническая поддержка
                </span>
              </li>
            </ul>
          </div>
          
          <div data-testid="footer-company">
            <h3 className="text-lg font-semibold mb-4">Компания</h3>
            <ul className="space-y-2">
              <li>
                <button 
                  onClick={() => scrollToSection('team')} 
                  className="text-gray-100 hover:text-white transition-colors text-left"
                  data-testid="footer-link-team"
                >
                  Команда
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('cases')} 
                  className="text-gray-100 hover:text-white transition-colors text-left"
                  data-testid="footer-link-portfolio"
                >
                  Портфолио
                </button>
              </li>
              <li>
                <span className="text-gray-100 hover:text-white transition-colors cursor-pointer" data-testid="footer-link-blog">
                  Блог
                </span>
              </li>
              <li>
                <span className="text-gray-100 hover:text-white transition-colors cursor-pointer" data-testid="footer-link-careers">
                  Карьера
                </span>
              </li>
            </ul>
          </div>
          
          <div data-testid="footer-contacts">
            <h3 className="text-lg font-semibold mb-4">Контакты</h3>
            <ul className="space-y-2 text-gray-100">
              <li data-testid="footer-contact-email">
                <a 
                  href="mailto:hello@sprintwise.ru" 
                  className="text-gray-100 hover:text-white transition-colors cursor-pointer"
                  data-testid="footer-email-link"
                >
                  hello@sprintwise.ru
                </a>
              </li>
              <li data-testid="footer-contact-phone">
                <a 
                  href="tel:+79264669322" 
                  className="text-gray-100 hover:text-white transition-colors cursor-pointer"
                  data-testid="footer-phone-link"
                >
                  +7 (926) 466-93-22
                </a>
              </li>
              <li data-testid="footer-contact-address">Москва, ул. Тверская, 1</li>
              <li data-testid="footer-contact-telegram">
                <a 
                  href="https://t.me/pprosvetov" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-gray-100 hover:text-white transition-colors cursor-pointer"
                  data-testid="footer-telegram-link"
                >
                  @pprosvetov
                </a>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-700 mt-8 pt-8 text-center">
          <p className="text-gray-200" data-testid="footer-copyright">
            © 2024 Sprintwise. Все права защищены.
          </p>
        </div>
      </div>
    </footer>
  );
}
